import { OpenInNew } from '@mui/icons-material'
import { GridRenderCellParams } from '@mui/x-data-grid'

import { ExternalLink } from '../../Link'

export const renderEmailCell = (params: GridRenderCellParams) => {
  return (
    <ExternalLink href={`mailto:${params.value}`}>
      {params.value} <OpenInNew sx={{ fontSize: 10 }} />
    </ExternalLink>
  )
}
